import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { useRoomCategories } from 'app/hooks/data/rooms/useRoomCategories';

export const useFilteredRooms = () => {
  const { publishedRooms, publishedPacks } = useContext(ModernHotelContext);
  const { data: roomsCategories, isFetching } = useRoomCategories();

  const sortedRooms = useMemo(() => {
    return [...publishedRooms].sort((a, b) => {
      const getAveragePriority = (roomId: number): number => {
        const priorities = publishedPacks
          .flatMap((pack) => pack.packRooms)
          .filter((pr) => pr.roomId === roomId)
          .map((pr) => pr.priority);

        if (priorities.length === 0) {
          return Infinity;
        }

        return priorities.reduce((sum, p) => sum + p, 0) / priorities.length;
      };

      return getAveragePriority(a.id) - getAveragePriority(b.id);
    });
  }, [publishedRooms, publishedPacks]);

  return {
    sortedRooms: sortedRooms.sort(
      (a, b) => (a.hotelPriority ?? Infinity) - (b.hotelPriority ?? Infinity)
    ),
    roomsCategories,
    isFetching,
  };
};
